import i18nImpl from 'live/services/i18n'

export const i18nPrefix = 'kpi.drillings.performance.'

const i18n = (key: string): string => {
    return i18nImpl(`${i18nPrefix}${key}`)
}

export default i18n
